import PropTypes from "prop-types";

import { OUTPUTS_TYPES } from "../../../../lib/utils/constants";

const EngineTranscodingOutputElementLabel = ({ type }) => {
  const isNdiType = type === OUTPUTS_TYPES.outputNdi.value;
  const isRtmpTypes = type === OUTPUTS_TYPES.outputRtmp.value;
  const isOutputUrlType = type === OUTPUTS_TYPES.outputUrl.value;
  const isOutputSDIType = type === OUTPUTS_TYPES.outputDecklink.value;

  if (isNdiType) {
    return OUTPUTS_TYPES.outputNdi.label;
  }

  if (isRtmpTypes) {
    return OUTPUTS_TYPES.outputUrl.label;
  }

  if (isOutputUrlType) {
    return OUTPUTS_TYPES.outputUrl.label;
  }

  if (isOutputSDIType) {
    return OUTPUTS_TYPES.outputDecklink.label;
  }

  return type && type.toUpperCase();
};

EngineTranscodingOutputElementLabel.propTypes = {
  type: PropTypes.string.isRequired,
};

export default EngineTranscodingOutputElementLabel;
